<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/171jv3y/images/9781250031907.jpg?1718046010860" alt="This image is the cover for the book Chose the Wrong Guy, Gave Him the Wrong Finger"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Chose the Wrong Guy, Gave Him the Wrong Finger
      </h1>
      <p class="bookDescription body article font2">
        <p>From Beth Harbison, the New York Times bestselling author of <i>When in Doubt, Add Butter</i> and <i>Shoe Addicts Anonymous,</i> comes <i>Chose the Wrong Guy, Gave Him the Wrong Finger</i>, a delightful new novel that will make you look at second chances in a whole new way.<br/><br/>Ten years ago, Quinn Barton was on her way to the altar to marry Burke Morrison, her high school sweetheart, when something derailed her. Rather, some<i>one </i>derailed her—the Best Man who at the last minute begged her to reconsider the marriage. He told her that Burke had been cheating on her. For a long time. Quinn, stunned, hurt, and confused, struggled with the obligation of fulfilling her guests' expectations—providing a wedding—and running for her life.<br/><br/>She chose running. With the Best Man. Who happened to be Burke's brother, Frank.<br/><br/>That relationship didn't work either. How could it, when Quinn had been engaged to, <i>in love with, </i>Frank's brother? Quinn opted for neither, and, instead, spends the next seventeen years working in her family's Middleburg, Virginia, bridal shop, <i>Talk of the Gown</i>, where she subconsciously does penance for the disservice she did to marriage.<br/><br/>But when the two men return to town for another wedding, old anger, hurt, and passion resurface. Just because you've traded the good guy for the bad guy for <i>no </i>guy doesn't mean you have to stay away from love for the rest of your life, does it? Told with Beth Harbison's flair for humor and heart, <i>Chose the Wrong Guy </i>will keep you guessing and make you believe in the possibilities of love.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beth Harbison
      </h2>
      
      <p class="authorDescription body article">BETH HARBISON is <I>The New York Times </I>bestselling author of <I>When in Doubt, Add Butter;</I><I>Always Something There To Remind Me; Thin, Rich, Pretty; Hope In A Jar; Secrets of a Shoe Addict </I>and <I>Shoe Addicts Anonymous</I>. She grew up in Potomac, Maryland, outside Washington, D.C., and now shares her time between that suburb, New York City and a quiet home on the eastern shore.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?755279ae